import {Component, computed, input, model} from '@angular/core';
import {IACKATHON_STEP} from '../../models/iackathon_steps';
import {IackathonSave} from '../../services/iackathon-saves.service';


@Component({
    selector: 'app-iackathon-progress-viewer',
    imports: [],
    templateUrl: './iackathon-progress-viewer.component.html',
    styleUrl: './iackathon-progress-viewer.component.scss',
})
export class IackathonProgressViewerComponent {
    save = input.required<IackathonSave>();
    activeState = model.required<IACKATHON_STEP>();

    private state = computed(() => this.save().attributes.content.state);

    protected isDone(str: IACKATHON_STEP): boolean {
        switch (str) {
            case('keyNumber'):
                return this.state().sdg_theme_step.top_group_answers.first_number.length > 0
                    && this.state().sdg_theme_step.top_group_answers.second_number.length > 0
                    && this.state().sdg_theme_step.top_group_answers.third_number.length > 0;
            case('problematic'):
                return this.state().problem_step.problematic.length > 0;
            case('howNowWow'):
                return this.state().dashboard.matrix_slot.complete;
            case('finalIdea'):
                return this.state().dashboard.final_idea.complete;
            case('canvas'):
                return this.state().dashboard.canvas.complete;
            case('deliverable'):
                return this.state().dashboard.deliverable.complete;
            case('ratingOthers'):
                return Object.keys(this.state().groups_project_reviews).length > 0; // TODO creer un "all done" coté iackhaton
            case('rate'):
                return false
            default:
                return false;
        }
    }

    protected onStepClick(step: IACKATHON_STEP) {
        this.activeState.set(step);
    }
}
